import { cn } from "@/utils/cn";
import { cva } from "class-variance-authority";

const badgeVariants = cva(
    "flex w-fit items-center justify-center border text-center text-xs font-medium",
    {
        variants: {
            variant: {
                primary:
                    "border-darkgreen-200 bg-darkgreen-500/40 text-darkgreen-100",
                secondary: "border-green-400 bg-green-700/40 text-green-25",
                success: "border-emerald-700 bg-emerald-950-40 text-emerald-25",
                danger: "border-red-300 bg-red-600-40 text-red-100",
                warning: "border-orange-500 bg-orange-800-40 text-orange-100",
                info: "border-blue-600 bg-blue-900-40 text-blue-25",
                light: "border-neutral-500 bg-neutral-200/40 text-neutral-600",
                white: "border-neutral-200 bg-white text-darkgreen-500",
                beige: "border-beige bg-beige text-darkgreen-500",
            },
            size: {
                default: "rounded-full px-2 py-1",
                sm: "size-6 min-w-fit rounded-full p-1",
                lg: "rounded-3xl px-3 py-2 text-sm/6 leading-none",
                xl: "rounded-3xl px-4 py-3 text-sm/6 leading-none",
            },
        },
        defaultVariants: {
            variant: "primary",
            size: "default",
        },
    },
);

export const Badge = ({ children, className, variant, size, ...props }) => {
    return (
        <div
            className={cn(badgeVariants({ className, variant, size }))}
            {...props}
        >
            {children}
        </div>
    );
};
